// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_int32 from "../../../../node_modules/rescript/lib/es6/caml_int32.js";

function CampaignProgressBarCmp(Props) {
  var target = Props.target;
  var current = Props.current;
  var status = Props.status;
  var completdWidth = String(Caml_int32.div(Math.imul(current, 100), target)) + "%";
  var inCompletdWidth = String(100 - Caml_int32.div(Math.imul(current, 100), target) | 0) + "%";
  return React.createElement("div", {
              className: "c-progress-bar"
            }, React.createElement("div", {
                  className: status,
                  style: {
                    width: completdWidth
                  }
                }), React.createElement("div", {
                  className: "incompleted",
                  style: {
                    width: inCompletdWidth
                  }
                }));
}

var make = CampaignProgressBarCmp;

export {
  make ,
  
}
/* react Not a pure module */
